// Libs
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Context
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import { useComponentsPool } from '../../../ComponentsPool';
import { Toast } from '../../notification/components';
import { useModal } from '../../modal/ModalContext';
// Actions
import createLoadingSelector from '../../layout/actions';
import { getRounds, addRoundsCsvFile } from '../actions';

const loadingSelector = createLoadingSelector(['ADD_ROUNDS_CSV_FILE']);
const ImportRoundsPopup = () => {
    const isLoading = useSelector(state => loadingSelector(state.layout.loading));
    const { Component } = useComponentsPool();
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const modal = useModal();
    const choosePicture = React.createRef();
    const [csvFile, setCsvFile] = useState('');
    const [isCompliantCsvFile, setIsCompliantCsvFile] = useState(false);

    const fileChangedHandler = e => {
        e.preventDefault();
        if (e.target.files?.length > 0) {
            setCsvFile(e.target.files[0]);
            if (e.target.files[0].size < 2500000) {
                setIsCompliantCsvFile(true);
            } else {
                setIsCompliantCsvFile(false);
                toast(
                    <Toast
                        isConfirm
                        message={t('notifications:is_not_compliant_device_csv')}
                        icon={'frown'}
                        type={'error'}
                    />, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        className: 'normal',
                        bodyClassName: 'notification-body grow-font-size',
                        progressClassName: 'error-custom-progress-bar'
                    }
                );
            }
        }
    };

    const addRounds = async () => {
        dispatch(addRoundsCsvFile(csvFile))
            .then(() => {
                dispatch(getRounds(true));
                modal.close();
            });
    };

    const Form = (
        <div className={'device-add-popup'}>
            <div className={'add-csv-file'}>
                <div className='doc-links'>
                    <a href="https://www.notion.so/merciyanis/fec8ddc329e143439d0f414fda6f96d9?v=35d73883060c450188b11a52bc37fb53&pvs=4" rel="noopener noreferrer" target="_blank">
                        {t('common:doc_link')}
                    </a>
                    <br />
                    <br />
                    <a href="https://docs.google.com/spreadsheets/d/1rglMyN95a4ikA2R7MLmvk7FXWaDZ97gHkv7N-2tCxOQ/edit#gid=0" rel="noopener noreferrer" target="_blank">
                        {t('common:csv_link')}
                    </a>
                </div>
                <Button
                    onClick={() => choosePicture.current.click()}
                >
                    <span>{t('devices:add_devices_csv_file')}</span>
                </Button>
            </div>
            <input
                ref={choosePicture}
                hidden
                type="file"
                accept=".csv"
                onChange={e => fileChangedHandler(e)}
            />
            <div>
                <span>{t('devices:chosen_file') + (csvFile ? ` ${ csvFile.name}` : ` ${ t('common:none')}`)}</span>
            </div>
        </div>
    );

    const disableSave = !isCompliantCsvFile || !csvFile;
    return (
        <>
            <Component componentName={'LoaderBarTop'} isLoading={isLoading} />
            <Component
                componentName={'Modal'}
                noOverflow
                head={<span className={'title-ticket-create-popup'}>{t('rounds:import_rounds')}</span>}
                content={Form}
                classNames={'ticket-create-popup'}
                submitButton
                submitButtonLabel={'common:save'}
                onHandleSubmit={addRounds}
                onSubmitDisabled={disableSave}
            />
        </>
    );
};
export default ImportRoundsPopup;
